import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";


interface FacilitadorState {
    status: string;
    error: string;
    facilitadorList: any[],
    facilitadorListActive: any[],
    facilitador: {
        idUsuario: number | null;
        user: string | null;
        clave: string | null;
        estado: number | null;
        primerNombre: string | null;
        segundoNombre: string | null;
        tercerNombre: string | null;
        primerApellido: string | null;
        segundoApellido: string | null;
        cui: string | null;
        idGenero: number | null;
        genero: string | null;
        fileImage: string | null;
        fileData: string | null;
        fechaNacimiento: Date | null;
        idOcupacion: number | null;
        ocupacion: string | null;
        detalleOcupacion: string | null;
    }

}

const initialState: FacilitadorState = {
    status: 'idle',
    error: '',
    facilitadorList: [],
    facilitadorListActive: [],
    facilitador: {
        idUsuario: null,
        user: null,
        clave: null,
        estado: null,
        primerNombre: null,
        segundoNombre: null,
        tercerNombre: null,
        primerApellido: null,
        segundoApellido: null,
        cui: null,
        idGenero: null,
        genero: null,
        fileImage: null,
        fileData: null,
        fechaNacimiento: null,
        idOcupacion: null,
        ocupacion: null,
        detalleOcupacion: null
    },
}

export const fetchFacilitador = createAsyncThunk('fetchFacilitador', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 31;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchFacilitadorActive = createAsyncThunk('fetchFacilitadorActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 109;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateFacilitador = createAsyncThunk('modifyCreateFacilitador', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    
    const facilitadorNew = selectFacilitador(state);
    const facilitadorAttributes = { ...facilitadorNew }
    const idsp = facilitadorAttributes.idUsuario ? 32 : 18;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...facilitadorAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (facilitadorAttributes.fileData != null && facilitadorAttributes.fileData !== '') {
            const { result } = await postFile({  idsp: 78, id: data, dir: "facilitador", fileData: facilitadorAttributes.fileData, fileName: data }, getState, dispatch);
            if (!result) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "IMAGEN NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchFacilitador({}));
    return rejectWithValue(message);
});

export const updateEstadoFacilitador = createAsyncThunk('updateEstadoFacilitador', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const usuarioNew = selectFacilitador(state);
    const usuarioAttributes = { ...usuarioNew }
    const estado = !usuarioAttributes.estado;
    const idUsuario = usuarioAttributes.idUsuario;
    const idsp = 7;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idUsuario }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchFacilitador({}));
    return rejectWithValue(message);
});

export const facilitadorSlice = createSlice({
    name: 'facilitador',
    initialState,
    reducers: {
        setFacilitadorList: (state, action) => {
            state.facilitadorList = action.payload;
        },
        setFacilitador: (state, action) => {
            state.facilitador = !action.payload ? initialState.facilitador : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchFacilitador.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFacilitador.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.facilitadorList = data ? data : [];

            })
            .addCase(fetchFacilitador.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchFacilitadorActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFacilitadorActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.facilitadorListActive = data ? data : [];

            })
            .addCase(fetchFacilitadorActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectFacilitadorList = (state: RootState) => state.facilitador.facilitadorList;
export const selectFacilitadorListActive = (state: RootState) => state.facilitador.facilitadorListActive;
export const selectFacilitador = (state: RootState) => state.facilitador.facilitador;

export const { setFacilitadorList, setFacilitador } = facilitadorSlice.actions;

export default facilitadorSlice.reducer;



